var _SBOX = (function () {
  var sbox = new Array(256);
  var p = 1,
    q = 1;
  function rotl8(x, s) {
    return ((x << s) | (x >> (8 - s))) & 0xff;
  }
  do {
    p = (p ^ (p << 1) ^ (p & 0x80 ? 0x11b : 0)) & 0xff;
    q ^= q << 1;
    q ^= q << 2;
    q ^= q << 4;
    q &= 0xff;
    if (q & 0x80) q ^= 0x09;
    q &= 0xff;
    var x = q ^ rotl8(q, 1) ^ rotl8(q, 2) ^ rotl8(q, 3) ^ rotl8(q, 4);
    sbox[p] = (x ^ 0x63) & 0xff;
  } while (p !== 1);
  sbox[0] = 0x63;
  return sbox;
})();

var _RCON = [0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d];

function _xtime(a) {
  return ((a << 1) ^ (a & 0x80 ? 0x11b : 0)) & 0xff;
}
function _mul(a, b) {
  var r = 0;
  while (b) {
    if (b & 1) r ^= a;
    a = _xtime(a);
    b >>= 1;
  }
  return r & 0xff;
}

function _expandKey(key) {
  var Nk = key.length / 4;
  var Nr = Nk + 6;
  var w = new Array(4 * (Nr + 1));
  var i;
  for (i = 0; i < Nk; i++) {
    w[i] = [key[4 * i], key[4 * i + 1], key[4 * i + 2], key[4 * i + 3]];
  }
  for (i = Nk; i < w.length; i++) {
    var t = w[i - 1].slice();
    if (i % Nk === 0) {
      t = [t[1], t[2], t[3], t[0]]; // RotWord
      t = [_SBOX[t[0]], _SBOX[t[1]], _SBOX[t[2]], _SBOX[t[3]]]; // SubWord
      t[0] ^= _RCON[i / Nk - 1];
    } else if (Nk > 6 && i % Nk === 4) {
      t = [_SBOX[t[0]], _SBOX[t[1]], _SBOX[t[2]], _SBOX[t[3]]]; // SubWord（仅 AES-256）
    }
    var p = w[i - Nk];
    w[i] = [p[0] ^ t[0], p[1] ^ t[1], p[2] ^ t[2], p[3] ^ t[3]];
  }
  return { w: w, Nr: Nr };
}

function _encryptBlock(block, ks) {
  var w = ks.w,
    Nr = ks.Nr;
  var s = block.slice();
  function addRoundKey(round) {
    for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) s[c * 4 + r] ^= w[round * 4 + c][r];
  }
  function subBytes() {
    for (var j = 0; j < 16; j++) s[j] = _SBOX[s[j]];
  }
  function shiftRows() {
    var t = s.slice();
    for (var r = 1; r < 4; r++) for (var c = 0; c < 4; c++) s[c * 4 + r] = t[((c + r) % 4) * 4 + r];
  }
  function mixColumns() {
    for (var c = 0; c < 4; c++) {
      var a0 = s[c * 4],
        a1 = s[c * 4 + 1],
        a2 = s[c * 4 + 2],
        a3 = s[c * 4 + 3];
      s[c * 4] = _mul(a0, 2) ^ _mul(a1, 3) ^ a2 ^ a3;
      s[c * 4 + 1] = a0 ^ _mul(a1, 2) ^ _mul(a2, 3) ^ a3;
      s[c * 4 + 2] = a0 ^ a1 ^ _mul(a2, 2) ^ _mul(a3, 3);
      s[c * 4 + 3] = _mul(a0, 3) ^ a1 ^ a2 ^ _mul(a3, 2);
    }
  }
  addRoundKey(0);
  for (var round = 1; round < Nr; round++) {
    subBytes();
    shiftRows();
    mixColumns();
    addRoundKey(round);
  }
  subBytes();
  shiftRows();
  addRoundKey(Nr);
  return s;
}

// AES-CBC + PKCS7 加密，返回密文字节数组。
function _aesCbcEncrypt(keyBytes, iv, data) {
  var ks = _expandKey(keyBytes);
  var pad = 16 - (data.length % 16);
  var buf = data.slice();
  for (var i = 0; i < pad; i++) buf.push(pad); // PKCS7
  var out = [];
  var prev = iv.slice();
  for (var off = 0; off < buf.length; off += 16) {
    var block = buf.slice(off, off + 16);
    for (var j = 0; j < 16; j++) block[j] ^= prev[j]; // CBC 异或前一密文块
    var enc = _encryptBlock(block, ks);
    for (var k = 0; k < 16; k++) out.push(enc[k]);
    prev = enc;
  }
  return out;
}

var _K = [
  103, 54, 51, 53, 100, 104, 52, 55, 58, 102, 57, 103, 105, 56, 52, 60, 53, 105, 54, 60, 57, 103, 101, 100, 100, 100, 60, 53, 100, 58, 53,
  60,
];

function _keyBytes() {
  return _K.map(function (c) {
    return c - 3;
  });
}

function _hexToBytes(hex) {
  var a = [];
  for (var i = 0; i < hex.length; i += 2) a.push(parseInt(hex.substr(i, 2), 16));
  return a;
}

function _bytesToHex(bytes) {
  var s = '';
  for (var i = 0; i < bytes.length; i++) s += (bytes[i] + 0x100).toString(16).slice(1);
  return s;
}

// 6 位十六进制随机 nonce（防查表）。仅作盐值，无需密码学强随机。
function _nonce() {
  return (Math.floor(Math.random() * 0x1000000) + 0x1000000).toString(16).slice(1);
}

/**
 * 加密单个拖拽距离。同步返回。
 * @param {number} distance    明文距离（像素），如 290。
 * @param {string} challengeHex 出题接口返回的 challenge 字段（32 位 hex），作 AES IV。
 * @returns {string} UUID 格式密文，如 "c1a1b528-9148-b8b0-b4ae-401f61705f2d"。
 */
function encryptDistance(distance, challengeHex) {
  var plain = distance + '|' + _nonce(); // 全 ASCII，charCode 即字节
  var data = [];
  for (var i = 0; i < plain.length; i++) data.push(plain.charCodeAt(i) & 0xff);
  var ct = _aesCbcEncrypt(_keyBytes(), _hexToBytes(challengeHex), data);
  return _bytesToHex(ct).replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');
}

/* ------------------------------------------------------------------ *
 * 用法示例（同步，无需 await）：
 *
 *   // 1) 出题：记下返回的 challenge
 *   const res = await uni.request({ url: "/", method: "POST",
 *     data: { captchaType: "SLIDE_PUZZLE" } });
 *   const { id, bgImage, blockImage, challenge } = res.data;
 *
 *   // 2) 用户拖拽得到 distance 后，加密提交
 *   const cipher = encryptDistance(290, challenge);
 *   await uni.request({ url: `/${id}/check`, method: "POST",
 *     data: { distance: [cipher] } });
 * ------------------------------------------------------------------ */

// 兼容 CommonJS / ESM / uniapp。
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { encryptDistance };
}
